import { render, staticRenderFns } from "./menuHandleIcon.vue?vue&type=template&id=4f46f141&"
import script from "./menuHandleIcon.vue?vue&type=script&lang=js&"
export * from "./menuHandleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports